import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { CartRow, CartService,BaseViewConfigService, ProductAssortmentParentService } from 'gung-standard';
import { JeevesSalesCartConfigService } from 'gung-standard-jeeves';
import { CarLinerSalesCartListComponent } from '../components/car-liner-sales-cart-list/car-liner-sales-cart-list.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerSalesCartConfigService extends JeevesSalesCartConfigService {
  constructor(
    protected cartService: CartService,
    protected baseViewConfigService: BaseViewConfigService,
    protected productAssortmentParentService: ProductAssortmentParentService
  ) {
    super(cartService, baseViewConfigService, productAssortmentParentService);
  }

  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart grid',
        getListItemComponent: () => CarLinerSalesCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
